export default __webpack_public_path__ + "static/media/2.2d5d2c25.jpg";